import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['favorite-toggler', {'favorite-toggler--active': _ctx.isFavorite }]),
    style: _normalizeStyle(`display: ${_ctx.isFavorite ? 'block' : ''}`),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
  }, null, 6))
}